import axiosPrivate from "@services/axiosPrivate";

export const updateDoctor = (doctorId, doctorObject) => {
  return axiosPrivate.put(`/updateDoctor/${doctorId}`, doctorObject);
};
